import { useState } from "react";
import MainContainer from "../../components/partials/maincontainer";
import Input from "../../components/partials/inputs";
import PrimaryBtn from "../../components/partials/btn";
import SuccessModal from "../../components/modals/successmodal";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { useApiCall } from "../../data/useFetcher";
import useAuthStore from "../../data/stores/authStore";
import { useLocation } from "react-router-dom";

export const MainSystemInformAreas = ({ title }: { title?: string }) => {
	const [modal, setModal] = useState(false),
		{ state } = useLocation();

	interface TitleEntry {
		title: string;
		_id?: string;
	}

	interface FormType {
		titles: TitleEntry[];
	}

	const {
		control,
		handleSubmit,
		formState: { errors },
		getValues,
	} = useForm<FormType>({
		defaultValues: {
			titles: state ? state?.data : [{ title: "" }],
		},
	});

	const { fields, append, remove } = useFieldArray({
		control,
		name: "titles",
	});

	const { onSubmitAPI, loading } = useApiCall();
	const { user, isAuth } = useAuthStore();

	const onSubmit = async (data: FormType) => {
		await onSubmitAPI({
			url: `/api/v1/system-inform-area`,
			type:
				// state ? "post" :
				"put",
			data: {
				systemInformArea: data.titles,
				type: state ? "update" : "create",
			},
			toggleModal: () => {
				setModal(true);
			},
		});
	};

	return (
		<div>
			<MainContainer>
				<div
					className={`${
						isAuth && user ? "" : "flex justify-center items-center"
					}`}>
					<div>
						<h3 className="text-4xl text-sec font-medium">
							{title || "System Inform Area"}
						</h3>
						<p className="text-base font-normal mt-4 max-w-sm text-[#667085]">
							Keep track of area updates
						</p>
						<form onSubmit={handleSubmit(onSubmit)} className="mt-8">
							<div className="space-y-4 w-96">
								{fields.map((field, index) => (
									<div key={field.id}>
										<Controller
											name={`titles.${index}.title`}
											control={control}
											rules={{
												required: "This field is required",
												validate: value => {
													const values = getValues("titles").map(t =>
														t.title.trim().toLowerCase()
													);
													const occurrences = values.filter(
														v => v === value.trim().toLowerCase()
													).length;
													if (occurrences > 1) {
														return "Each title must be unique";
													}
													return true;
												},
											}}
											render={({ field: { value, onChange, name } }) => (
												<Input
													type="text"
													value={value}
													onChange={onChange}
													placeholder="Enter System Inform Area"
													label={`Enter System Inform Area title ${index + 1}*`}
													name={name}
												/>
											)}
										/>
										{errors?.titles?.[index]?.title && (
											<p className="text-[#dc2626] text-xs">
												{errors.titles[index]?.title?.message}
											</p>
										)}
										{fields.length > 1 && !state && (
											<button
												type="button"
												onClick={() => remove(index)}
												className="text-red-500 text-xs mt-1">
												Remove
											</button>
										)}
									</div>
								))}
								{!state && (
									<button
										type="button"
										onClick={() => append({ title: "" })}
										className="text-blue-600 text-sm">
										+ Add another title
									</button>
								)}
							</div>
							<div className="mt-8">
								<PrimaryBtn
									text="Continue"
									width="w-96"
									loading={!!loading}
									type="submit"
								/>
							</div>
						</form>
					</div>
				</div>
			</MainContainer>
			{modal && (
				<SuccessModal
					page="/system-inform-area"
					title={`${title || "System Inform Area"} Submission Completed`}
					desc="Area Updated Successfully."
				/>
			)}
		</div>
	);
};

const SystemInformAreas = () => <MainSystemInformAreas />;

export default SystemInformAreas;
